export default "__VITE_ASSET__Ca0_Frdy__"